import React from 'react'
import MedicationFollowUpRegister from 'components/screens/MedicationFollowUpRegister'

export default function MedicationFollowUpRegisterContainer() {
  return <MedicationFollowUpRegister />
}
